import { definePreset } from '@primeng/themes';
import Lara from '@primeng/themes/lara';

const LaraLightBlue = definePreset(Lara, {
  semantic: {
    // Primary color shades for light mode
    primary: {
      0: '#ffffff',
      50: '{slate.50}',
      100: '{slate.100}',
      200: '{slate.200}',
      300: '{slate.300}',
      400: '{slate.400}',
      500: '{slate.500}',
      600: '{slate.600}',
      700: '{slate.700}',
      800: '{slate.800}',
      900: '{slate.900}',
      950: '{slate.950}',
    },
    colorScheme: {
      light: {
        primary: {
          color: '#000000',
          contrastColor: '#ffffff',
          hoverColor: '#111111',
          activeColor: '#212121',
        },
        surface: {
          // 0: '#ffffff',
          // 50: '{zinc.50}',
          // 100: '{zinc.100}',
          // 200: '{zinc.200}',
          // 300: '{zinc.300}',
          // 400: '{zinc.400}',
          // 500: '{zinc.500}',
          // 600: '{zinc.600}',
          // 700: '{zinc.700}',
          // 800: '{zinc.800}',
          // 900: '{zinc.900}',
          // 950: '{zinc.950}',
        },
      },

      dark: {
        surface: {
          0: '#ffffff',
          50: '{zinc.50}',
          100: '{zinc.100}',
          200: '{zinc.200}',
          300: '{zinc.300}',
          400: '{zinc.400}',
          500: '{zinc.500}',
          600: '{zinc.600}',
          700: '{zinc.700}',
          800: '{zinc.800}',
          900: '{zinc.900}',
          950: '{zinc.950}',
        },

        primary: {
          color: '#ffffff',
          contrastColor: '#000000',
          hoverColor: '#e0e0e0',
          activeColor: '#bdbdbd',
        },
      },
      // dark: {
      //   primary: {
      //     color: '#ffffff',
      //     inverseColor: '#000000',
      //     hoverColor: '#e0e0e0',
      //     activeColor: '#bdbdbd',
      //   },
      //   surface: {
      //     //0: '#1a1a1a',
      //     // 50: '{gray.800}',
      //     // 100: '{gray.900}',
      //     // 200: '{gray.950}',
      //   },
      // },
    },
  },
  components: {
  },
});

export default LaraLightBlue;
